import axios from "axios";
const administration_url = process.env.VUE_APP_XMARTSHELF_ADMINISTRATION;

const state = {
  selectedDeliveryOption: null,
  deliveryOptions: [],
  amountDeliveryConfigs: 0,
  paginationOptions: {
    itemsPerPage: 10,
    currentPage: 1,
    totalPages: 0,
    filters: {}
  }
};
const getters = {
  getPaginationsOptions(state) {
    return state.paginationOptions;
  },
  getTotalPages(state) {
    return state.paginationOptions.totalPages;
  },
  getCurrentPage(state) {
    return state.paginationOptions.currentPage;
  },
  getFilters(state) {
    return state.paginationOptions.filters;
  },
  getItemsPerPage(state) {
    return state.paginationOptions.itemsPerPage;
  },
  selectedDeliveryOption(state) {
    return state.selectedDeliveryOption;
  },
  deliveryOptions(state) {
    return state.deliveryOptions;
  },
  hasDeliveryConfigs(state) {
    return state.amountDeliveryConfigs > 0;
  }
};

const mutations = {
  setTotalPages(state, totalPages) {
    state.paginationOptions.totalPages = Math.ceil(totalPages / 10);
  },
  setCurrentPage(state, currentPage) {
    state.paginationOptions.currentPage = currentPage;
  },
  setFilters(state, filters) {
    state.paginationOptions.filters = filters;
  },
  setSelectedOption(state, option) {
    state.selectedDeliveryOption = option;
  },
  setDeliveryOptions(state, options) {
    state.deliveryOptions = options;
  },
  setAmountDeliveryConfigs(state, amount) {
    state.amountDeliveryConfigs = amount;
  }
};

const actions = {
  loadDeliveryOptions({ getters, commit }, filter) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${administration_url}/delivery_config/list/${getters.getSelectedStore.id}`,
          {
            params: {
              skip: (getters.getCurrentPage - 1) * getters.getItemsPerPage,
              take: getters.getItemsPerPage,
              filters: JSON.stringify(filter)
            }
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then((response) => {
          commit("setDeliveryOptions", response.data.deliveryConfigs);
          commit("setTotalPages", response.data.count);
          commit("setAmountDeliveryConfigs", response.data.total);
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  },
  saveDeliveryOption({ getters, dispatch }, deliveryOption) {
    return new Promise((resolve) => {
      axios
        .post(
          `${administration_url}/delivery_config`,
          {
            id: deliveryOption.id || undefined,
            store_id: getters.getSelectedStore.id,
            active: deliveryOption.active,
            title: deliveryOption.title,
            delivery_time: deliveryOption.delivery_time,
            distance_in_kilometers: deliveryOption.distance_in_kilometers,
            delivery_fee: deliveryOption.delivery_fee || 0,
            minimum_value_free_shipping:
              deliveryOption.minimum_value_free_shipping || 0,
            minimum_value_shipping: deliveryOption.minimum_value_shipping || 0
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then(() => {
          dispatch("loadDeliveryOptions");
          resolve({ sucess: true });
        })
        .catch((error) => {
          console.log(error);
          resolve({ sucess: false, message: error.response.data.message });
        });
    });
  },
  deleteDeliveryOption({ dispatch }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${administration_url}/delivery_config/${id}`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
          }
        })
        .then(() => {
          dispatch("loadDeliveryOptions");
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  },
  bulkUpdateStatusDeliveryOptions({ dispatch }, { ids, active }) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${administration_url}/delivery_config/bulk_update_status`,
          {
            ids,
            active
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then(() => {
          dispatch("loadDeliveryOptions");
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  },
  bulkDeleteDeliveryOptions({ dispatch }, ids) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${administration_url}/delivery_config/bulk_delete`,
          {
            ids
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json"
            }
          }
        )
        .then(() => {
          dispatch("loadDeliveryOptions");
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
